import React from 'react';

import styled from 'styled-components';

import { Checkbox } from '@atlaskit/checkbox';
import type { CheckboxProps } from '@atlaskit/checkbox';
import Tooltip from '@atlaskit/tooltip';
import type { TooltipProps } from '@atlaskit/tooltip';

export type Props = {
  tooltipProps: Omit<TooltipProps, 'children'>;
  checkboxProps: CheckboxProps;
};

export const ContainerStyled = styled.div`
  > div {
    width: 24px;
    height: 24px;
  }
`;

// This component is a hack to make a disabled checkbox working with tooltip
const CheckboxWithTooltip = ({
  tooltipProps,
  checkboxProps,
}: Props): JSX.Element => {
  return (
    <Tooltip {...tooltipProps}>
      <span
        style={
          checkboxProps?.isDisabled
            ? {
                cursor: 'not-allowed',
              }
            : {}
        }
      >
        <Checkbox
          {...checkboxProps}
          style={
            checkboxProps?.isDisabled
              ? {
                  pointerEvents: 'none',
                }
              : {}
          }
        />
      </span>
    </Tooltip>
  );
};

export default CheckboxWithTooltip;
